export const LOCAL_STORAGE_KEYS = {
  PAGES_MENU: 'pages_menu'
};
